export enum TipoPropostaEnum {
  PROPRIA = 'PROPRIA',
  INDICADA = 'INDICADA',
  RECEBIDA = 'RECEBIDA'
}
